import * as React from 'react';
import RoutePrivate from '../router/RoutePrivate';

import ContactsPage from './ContactsPage';

export default function getRoutes(isLoggedIn: boolean) {
    return [<RoutePrivate key="contacts" path="/contacts" component={ContactsPage} isLoggedIn={isLoggedIn} />];
}



// WEBPACK FOOTER //
// ./src/components/contacts/Contact.Routes.tsx